// pkg198 — local preview of the installment schedule. Matches
// lawpaySaved.buildInstallments in the backend (weekly / biweekly / monthly,
// last installment is the remainder, 120 installment cap). The server rebuilds
// the schedule on create; this is only the preview shown before save.

const MAX_INSTALLMENTS = 120;

function isoDate(value) {
  if (!value) return null;
  const m = String(value).match(/^(\d{4}-\d{2}-\d{2})/);
  return m ? m[1] : null;
}

function addDays(iso, n) {
  const [y, m, d] = iso.split('-').map(Number);
  const dt = new Date(Date.UTC(y, m - 1, d + n));
  return dt.toISOString().slice(0, 10);
}

function addMonths(iso, n) {
  const [y, m, d] = iso.split('-').map(Number);
  const first = new Date(Date.UTC(y, m - 1 + n, 1));
  const last = new Date(Date.UTC(first.getUTCFullYear(), first.getUTCMonth() + 1, 0)).getUTCDate();
  const day = Math.min(d, last);
  return new Date(Date.UTC(first.getUTCFullYear(), first.getUTCMonth(), day)).toISOString().slice(0, 10);
}

function addFrequency(iso, frequency) {
  if (frequency === 'weekly') return addDays(iso, 7);
  if (frequency === 'biweekly') return addDays(iso, 14);
  if (frequency === 'monthly') return addMonths(iso, 1);
  return null;
}

export function buildInstallmentSchedule({ total, installmentAmount, frequency, startDate }) {
  if (!['weekly', 'biweekly', 'monthly'].includes(frequency)) {
    return { error: 'frequency must be weekly, biweekly, or monthly' };
  }
  const start = isoDate(startDate);
  if (!start) return { error: 'start_date must be YYYY-MM-DD' };
  const totalCents = Math.round(Number(total) * 100);
  const instCents = Math.round(Number(installmentAmount) * 100);
  if (!(totalCents > 0)) return { error: 'total must be positive' };
  if (!(instCents > 0)) return { error: 'installment_amount must be positive' };
  if (instCents > totalCents) return { error: 'installment_amount cannot exceed the total' };
  const count = Math.ceil(totalCents / instCents);
  if (count > MAX_INSTALLMENTS) return { error: `A plan cannot exceed ${MAX_INSTALLMENTS} installments` };
  const rows = [];
  let cursor = start;
  for (let i = 0; i < count; i++) {
    const cents = i === count - 1 ? totalCents - instCents * (count - 1) : instCents;
    rows.push({
      sequence: i + 1,
      due_date: cursor,
      amount: +(cents / 100).toFixed(2),
    });
    cursor = addFrequency(cursor, frequency);
  }
  return { installments: rows };
}
